import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ApiButton, Box, CustomSelect, ErrorInfo, Progress, SectionHeader } from 'web-library';
import { useGetUserSettings } from '../../../api-refactored/user/useGetUserSettings';
import { usePutUserSettings } from '../../../api-refactored/user/usePutUserSettings';
import { DefaultOtpType } from '../../../api/user/model';

const useStyles = makeStyles()((theme) =>
({
  container: {},
  sectionText: {
    paddingBottom: theme.spacing(2),
  },
  selectContainer: {
    paddingBottom: theme.spacing(2),
  },
  button: {
    width: 200,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

export interface SettingFormData {
  otpType: string;
}

const tfaValue = [
  { children: 'Email', key: 'email', value: 'EMAIL' },
  { children: 'SMS', key: 'sms', value: 'SMS' },
];
const tfaDefaultValue = tfaValue[0].value;

const TwoFactorAuthenticationSetting = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [selectedTfa, setSelectedTfa] = useState(tfaDefaultValue);
  const [errorMsg, setErrorMsg] = useState('');
  const { data: dataSettings, isFetching: isLoadingProfile } = useGetUserSettings({
    onSuccess: (res) => {
      setSelectedTfa(res.otpType);
    },
  });
  const userProfileMutation = usePutUserSettings({
    onSuccess: () => {
      setErrorMsg('');
    },
    onError: (err) => {
      if (err.response?.data?.code === '1213') {
        setErrorMsg(t('profile->>TwoFactorAuthenticationSetting.NoNumberErrorMsg'));
      } else {
        setErrorMsg(t('components->>Error.DefaultErrorMsg'));
      }
    },
  });
  const settingForm = useForm<SettingFormData>();
  const onFormSubmit = (formData: SettingFormData) => {
    userProfileMutation.mutate({
      otpType: selectedTfa as DefaultOtpType,
    });
  };

  if (isLoadingProfile) {
    return <Progress color="secondary" />;
  }

  return (
    <form onSubmit={settingForm.handleSubmit(onFormSubmit)}>
      {dataSettings?.credentialType === 'USERNAME' && (
        <Box className={classes.container}>
          <SectionHeader title={t('profile->>TwoFactorAuthenticationSetting.Setting 2FA')} />

          <Box className={classes.selectContainer}>
            <CustomSelect
              label={t('profile->>TwoFactorAuthenticationSetting.Default method')}
              labelId="inputSelectLabel-defaultOtp"
              id="inputSelect-defaultOtp"
              variant="filled"
              defaultValue={selectedTfa}
              menuItems={tfaValue}
              onChange={(event) => setSelectedTfa(event.target.value as DefaultOtpType)}
            />
          </Box>
          <Box className={classes.button}>
            <ApiButton status={userProfileMutation.status} type="submit">
              {t('profile->>TwoFactorAuthenticationSetting.Save')}
            </ApiButton>
          </Box>
          <ErrorInfo label={errorMsg || ''} />
        </Box>
      )}
    </form>
  );
};

export default TwoFactorAuthenticationSetting;
